/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Profile_ScenaristInputs */



/**
* | output |
* | --- |
* | "Scenarist Script (DVD)" |
*
* @param {Image_Export_Profile_ScenaristInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_profile_scenarist = /** @type {((inputs?: Image_Export_Profile_ScenaristInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Profile_ScenaristInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Scenarist Script (DVD)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Scenarist Script (DVD)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scenarist Script (DVD)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Scenarist Script (DVD)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Scenarist Script (DVD)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Scenarist Script（DVD）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Scenarist Script（DVD）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Scenarist Script (DVD)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Scenarist Script (DVD)")
	return /** @type {LocalizedString} */ ("Scenarist Script (DVD)")
});